/* eslint-disable import/no-unresolved */
import 'antd/dist/reset.css';
import Loader from 'component/Loader/Loader';
import LoaderContextProvider from 'component/Loader/LoaderContextProvider';
import PropertyContextProvider from 'component/PropertyContext/PropertyContext';
import { Suspense, useEffect, useState } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import AppRoutes from './AppRoutes';
import routeConfig from './constants/route.config';
import 'react-image-gallery/styles/css/image-gallery.css';
import CustomLoader from 'component/Loader/CustomLoader';
import { generateToken, requestNotificationPermission } from './firebase';
import NetworkStatus from './NetworkStatus';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import retrexlogo from 'assets/images/loading.png';
import { Notifications } from '@mui/icons-material';
import { FCM_TOKEN, USER_MAIL_ID } from 'constant/app.config';
import { postApiCall } from 'api/apiService';

function App() {
  const [showPrompt, setShowPrompt] = useState(false);
  const notificationPermission =
    'Notification' in window ? Notification.permission : 'denied';

  const [permission, setPermission] = useState(notificationPermission);
  const theme = useTheme();
  const matches500 = useMediaQuery(theme.breakpoints.down(500));

  // Global Browser Back Button Handler
  useEffect(() => {
    const handleBackButton = () => {
      window.location.reload();
    };

    window.addEventListener('popstate', handleBackButton);

    return () => {
      window.removeEventListener('popstate', handleBackButton);
    };
  }, []);

  const handleEnableNotifications = async () => {
    setShowPrompt(false);
    try {
      const token = await requestNotificationPermission();
      console.error('Token generation', token);
    } catch (error) {
      console.error('Failed to enable notifications:', error);
    }
  };

  // Detect permission changes while browsing
  useEffect(() => {
    const checkPermission = async () => {
      if (!('Notification' in window)) {
        return;
      }

      const current = Notification.permission;
      if (current !== permission) {
        console.log(
          `Notification permission changed: ${permission} → ${current}`
        );
        setPermission(current);

        if (current === 'granted') {
          // User turned ON notifications
          await generateToken();
          let fcmtoken = {
            firebaseToken: sessionStorage.getItem('FCMTOKEN'),
            userEmail: USER_MAIL_ID,
            firebaseTokenFor: matches500 ? 'App' : 'Web',
          };
          postApiCall(FCM_TOKEN, fcmtoken).then((fcm_res) => {});
        } else if (current === 'denied') {
          // User turned OFF notifications
        }
      }
    };

    // Check when window gains focus (user returns from browser settings)
    window.addEventListener('focus', checkPermission);

    // Optional: poll every 5–10 seconds for safety
    const interval = setInterval(checkPermission, 10000);

    return () => {
      window.removeEventListener('focus', checkPermission);
      clearInterval(interval);
    };
  }, [permission]);

  const handleDismiss = () => {
    setShowPrompt(false);
  };

  useEffect(() => {
    const checkPermission = async () => {
      if (!('Notification' in window)) {
        return;
      }

      // Always re-check after a short delay
      const current = Notification.permission;

      if (current === 'granted') {
        await generateToken(); // normal sync
      } else if (current === 'default') {
        // Small debounce - browser may just be catching up
        setTimeout(() => {
          if (Notification.permission === 'granted') {
            generateToken();
          } else {
            setShowPrompt(true);
          }
        }, 500); // half a second is usually enough
      }
    };

    checkPermission();
  }, []);

  return (
    <div id="retrex">
      <NetworkStatus />

      <LoaderContextProvider sx={{ overflow: 'scroll' }}>
        <CustomLoader />
        <PropertyContextProvider>
          <Suspense fallback={<Loader forced />}>
            <AppRoutes routeConfig={routeConfig} />
          </Suspense>
          <Loader />
        </PropertyContextProvider>
      </LoaderContextProvider>

      {/* MUI Dialog for notification request */}
      <Dialog
        open={showPrompt}
        onClose={handleDismiss}
        aria-labelledby="notification-dialog-title"
        PaperProps={{
          sx: {
            borderRadius: 3,
            p: 2,
          },
        }}
      >
        <DialogTitle
          id="notification-dialog-title"
          sx={{
            textAlign: 'center',
            fontFamily: 'poppins',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Notifications sx={{ color: '#F1CB1E' }} />
          Enable Notifications
        </DialogTitle>

        <DialogContent>
          <Typography
            variant="body1"
            sx={{ textAlign: 'center', mb: 2, fontFamily: 'poppins' }}
          >
            Stay updated with important alerts from retreX. Please allow
            notifications to never miss an update.
          </Typography>

          <Box
            component="img"
            src={retrexlogo}
            alt="Notification Bell"
            sx={{
              width: 100,
              height: 100,
              display: 'block',
              mx: 'auto',
            }}
          />
        </DialogContent>

        <DialogActions sx={{ justifyContent: 'center', gap: 2 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleEnableNotifications}
            sx={{ borderRadius: 2, px: 4 }}
          >
            Allow
          </Button>
          {/* <Button
            variant="outlined"
            color="secondary"
            onClick={handleDismiss}
            sx={{ borderRadius: 2, px: 4 }}
          >
            Not Now
          </Button> */}
        </DialogActions>
      </Dialog>
    </div>
  );
}
export default App;
